import { color } from 'asserts/styles/colors';
import styled from 'styled-components';

const Adress = () => {
  return (
    <>
      <TextWrapper>
        <h3>고객센터 02-6925-6080</h3>
        <p>운영시간 평일 09:00AM ~ 05:00 PM</p>
      </TextWrapper>
      <Line />
      <TextWrapper>
        <p>주식회사 엑스바디</p>
        <p>서울시 금천구 가산디지털 1로 151, 이노플렉스 BD, 9F</p>
        <AddressWrapper>
          <p>대표번호 02-6925-6080</p>
          <p>FAX 02-6925-6077</p>
          <p>사업자등록번호 119-86-49785</p>
        </AddressWrapper>
        <p>Copyright 2023. exbody all rights reserved.</p>
      </TextWrapper>
    </>
  );
};
export default Adress;

const TextWrapper = styled.div`
  & h3 {
    padding: 16px 0 8px;
    font-weight: 500;
    line-height: 20px;
  }

  & p {
    padding-bottom: 6px;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
  }
`;

const Line = styled.hr`
  margin: 10px 0 16px;
  color: ${color.white01};
  border: 1px solid ${color.white01};
`;

const AddressWrapper = styled.div`
  display: flex;

  & p:not(:first-of-type) {
    margin-left: 16px;
  }
`;
